import React from 'react'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'
import GameplanCard from './GameplanCard'
import { getPossibleProfileImage } from '../managers/ImageHelper'
import Constants from './Constants'

export default class UserCellView extends React.Component { 

	render() { 
		return (
			<div style={{...Constants.centeredDiv, ...{textAlign: 'center'}, ...this.props.style}}>	
				<div>
				<Image
					width={80}
					height={80}
					className="mr-3"
					src={getPossibleProfileImage(this.props.image_url)}
					alt="Generic placeholder"
					style={{marginBottom: 10, marginRight: '0px !important'}}
					roundedCircle 
				/>

				<div style={{marginBottom: 20}}>
				<Button variant="link" onClick={() => this.props.handleNameClick(this.props.username)}>{this.props.username}
				</Button>
				</div>

				{this.props.title && <p style={{color:Constants.grayColor}}><strong>{this.props.title}</strong></p>}

				{this.props.bio && <p style={{color: Constants.grayColor}}>{this.props.bio}</p>}
				{this.props.email && <a href={"mailto:" + this.props.email}>Contact</a>}
				</div>
			</div>
			)
	}
}